import { Media, Spacing } from '@doordash/design-language'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: space-evenly;
  height: calc(100vh - 200px);

  ${Media.Mobile`
    height: 100vh;
  `}
`

export const Top = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
  padding: ${Spacing.XxxLarge}px ${Spacing.Small}px 0 ${Spacing.Small}px;
`
export const Bottom = styled.div`
  width: 100%;
  padding: ${Spacing.Small}px ${Spacing.Small}px ${Spacing.XLarge}px;
`
